import XLSX from 'xlsx'

const XLSX_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
const REVOKE_DELAY = 60000

// XLSX.writeFile reaches for the node fs module, which the non-production builds replace by a throwing stub
export const Workbook = {
  download (workBook: XLSX.WorkBook, fileName: string) {
    const data = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' })
    const url = URL.createObjectURL(new Blob([data], { type: XLSX_TYPE }))
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY)
  }
}
